import commonMessages from '@rhg/lang/messages/common';
import { useIntl } from 'react-intl';
import AnimatedScreenMessage from '../animated-screen-message';
import Page from '../page';
import PageTitle from '../page-title';

interface GeneralErrorProps {
    header?: string;
    body?: string;
}

const GeneralError = ({ header, body }: GeneralErrorProps) => {
    const { formatMessage } = useIntl();

    const errorHeader: string =
        header ||
        formatMessage(commonMessages['common.error.general.page_header']);
    const errorBody: string =
        body || formatMessage(commonMessages['common.error.general.page_body']);

    return (
        <>
            <PageTitle title={errorHeader} />
            <Page>
                <AnimatedScreenMessage
                    title={errorHeader}
                    subtitle={errorBody}
                    displayHomeButton
                    displayLogo
                />
            </Page>
        </>
    );
};

export default GeneralError;
